import { createClient } from '@supabase/supabase-js';

function normalizeUrl(raw) {
  const u = (raw || '').trim().replace(/\/+$/, '');
  return u;
}

/** CRA(react-scripts)는 빌드 시점에 process.env.REACT_APP_* 만 번들에 주입합니다. */
function readConfigFromEnv() {
  const fromEnvUrl = normalizeUrl(process.env.REACT_APP_SUPABASE_URL);
  const fromEnvJwt = (process.env.REACT_APP_SUPABASE_JWT_ANON_KEY || '').trim();
  const fromEnvAnon = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

  return {
    url: fromEnvUrl,
    anonKey: fromEnvJwt || fromEnvAnon,
    fromEnvUrl: Boolean(fromEnvUrl),
    fromEnvJwt: Boolean(fromEnvJwt),
    fromEnvAnon: Boolean(fromEnvAnon),
    hardcoded: false,
  };
}

const cfg = readConfigFromEnv();
const url = cfg.url;
const anonKey = cfg.anonKey;

/** Build-time flag: `REACT_APP_SUPABASE_URL` + anon key present. Boolean constant — not a function. */
export const isSupabaseConfigured = Boolean(url && anonKey);

let client;
let lastClientKey = '';

/**
 * Returns a singleton Supabase client, or null when env is missing (tests / local fallback).
 */
export function getSupabase() {
  if (!isSupabaseConfigured) return null;

  const fingerprint = `${url}::${anonKey}`;
  if (client && lastClientKey === fingerprint) return client;

  client = createClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
  lastClientKey = fingerprint;
  return client;
}

/** 로그아웃·OAuth 재시도 전 남은 PKCE/세션 키 제거 */
export function clearSupabaseLocalAuthStorage() {
  if (typeof window === 'undefined') return;
  try {
    for (const key of Object.keys(window.localStorage)) {
      if (key.startsWith('sb-') && key.includes('auth-token')) {
        window.localStorage.removeItem(key);
      }
    }
  } catch {
    /* ignore */
  }
}
